import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MarksMapperService {
  totalMark(CorrectQuestions: number, TotalQuestions) {
    return (CorrectQuestions / TotalQuestions) * 10;
  }

  rangeMapper(lowRange: number, highRange: number, mark: number): boolean {
    if ((mark >= lowRange && mark < highRange) || (mark >= lowRange && mark <= highRange && mark === 10)) {
      return true;
    } else false;
  }
  rubricName(lowRange: number, highRange: number): string {
    let name = '';
    switch (true) {
      case lowRange >= 0 && highRange <= 5:
        name = 'emoji-bad';
        break;
      case lowRange >= 5 && highRange <= 7:
        name = 'emoji-regular';
        break;
      case lowRange >= 7 && highRange <= 9:
        name = 'emoji-good';
        break;
      case lowRange >= 9 && highRange <= 10:
        name = 'emoji-excellent';
        break;
    }
    return name;
  }
}

export enum EmojisRubric {
  BAD = 'emoji-bad',
  REGULAR = 'emoji-regular',
  GOOD = 'emoji-good',
  EXCELLENT = 'emoji-excellent',
}
